import React, { Component } from 'react';
import Usuario from '../../Utils/Usuario';
import { NavLink } from 'react-router-dom'
import { Permissions } from './../../Utils/Permissions';
import './Home.scss';


class Home extends Component {

    constructor() {
        super();

        this.checkPerm = this.checkPerm.bind(this);

        this.state = {

        }

        this.cardsHomeMOCK = [
            // {
            //     nome: "Atendimentos",
            //     link: 'atendimentos/lista',
            //     paginaPerm: 'atendimento',
            //     icon: "fas fa-headset icone"
            // },
            {
                nome: "Pedidos",
                link: 'pedidos/lista',
                paginaPerm: 'pedidos',
                icon: "fas fa-file-alt icone"
            },
            {
                nome: "Avisos",
                link: 'avisos/lista',
                paginaPerm: 'avisos',
                icon: "fal fa-exclamation-circle icone"
            },
            {
                nome: "Logística",
                link: 'logistica/remessas',
                paginaPerm: 'logística',
                icon: "fas fa-truck icone"
            },
            {
                nome: "Cile",
                link: "cile/pedidos/lista",
                paginaPerm: 'atendimento',
                icon: 'fas fa-book-reader icone'
            },
            {
                nome: "Produtos",
                link: 'produtos/lista',
                paginaPerm: 'produtos',
                icon: "fa-newspaper icone"
            },
            {
                nome: "Faturamento",
                link: 'faturamento/lista-processados',
                paginaPerm: 'faturamento',
                icon: "fas fas fa-file-invoice-dollar icone"
            },
            {
                nome: "Usuários",
                link: 'usuarios',
                paginaPerm: 'admin',
                icon: "fas fa-users icone"
            },
            {
                nome: "Conteúdo BS",
                link: 'conteudo/bs?pagina=1&limite=10',
                paginaPerm: 'conteúdo',
                numeroPerm: 5,
                icon: "fas fa-pen text-primary"
            },
            {
                nome: "Conteúdo BJ",
                link: 'conteudo/bj?pagina=1&limite=10',
                paginaPerm: 'conteúdo',
                numeroPerm: 28,
                icon: "fas fa-pen text-success"
            },
            {
                nome: "Conteúdo TC",
                link: 'conteudo/tc?pagina=1&limite=10',
                paginaPerm: 'conteúdo',
                numeroPerm: 6,
                icon: "fas fa-pen text-danger"
            },
            {
                nome: "Conteúdo RDez",
                link: 'conteudo/rd?pagina=1&limite=10',
                paginaPerm: 'conteúdo',
                numeroPerm: 7,
                icon: "fas fa-pen text-warning"
            },
            {
                nome: "Conteúdo BS+ App",
                link: 'conteudo/bm/artigos?pagina=1&limite=20',
                paginaPerm: 'conteúdo',
                numeroPerm: 8,
                icon: "fas fa-pen text-info"
            },
            {
                nome: "Frase do Dia",
                link: 'frase-do-dia/lista?pagina=1&limite=10',
                paginaPerm: 'conteúdo',
                numeroPerm: 13,
                icon: "fas fa-pen text-orange"
            },
            {
                nome: "Vídeos",
                link: 'multimidia/videos?pagina=1&limite=10',
                paginaPerm: 'conteúdo',
                numeroPerm: 10,
                icon: "fas fa-film text-purple"
            },
            {
                nome: "Podcasts",
                link: 'multimidia/podcasts?pagina=1&limite=10',
                paginaPerm: 'conteúdo',
                numeroPerm: 11,
                icon: "fas fa-podcast text-primary"
            },
            {
                nome: "Áreas Especiais",
                link: 'areas-especiais',
                paginaPerm: 'conteúdo',
                numeroPerm: 12,
                icon: "fas fa-columns text-pink"
            },
            {
                nome: "Coord. Periódicos",
                link: 'coordenadores-periodicos',
                paginaPerm: 'coordenadores de periódicos',
                numeroPerm: 17,
                icon: "fas fa-user-friends text-pink"
            },
            {
                nome: "Destaques",
                link: 'destaques/lista',
                paginaPerm: 'conteúdo',
                numeroPerm: 12,
                icon: "fas fa-columns text-pink"
            },
            {
                nome: "Publicidades",
                link: 'publicidades',
                paginaPerm: 'conteúdo',
                numeroPerm: 12,
                icon: "fas fa-bullhorn text-primary"
            },
            {
                nome: "Painel de KPIs",
                link: '/kpis',
                paginaPerm: 'kpis',
                numeroPerm: 12,
                icon: "fa-regular fa-chart-line"
            },
            // {
            //     nome: "Perfil",
            //     link: 'alterar-senha',
            //     paginaPerm: 'conteúdo',
            //     // numeroPerm: 8,
            //     icon: "fas fa-user-cog icone"
            // },
        ];
    }



    componentWillMount() {
        const _arrPerm = Usuario.getLoggedUser.permissoes.map(item => item.numero);
        // console.log("🚀 ~ Home ~ componentWillMount ~ _arrPerm:", _arrPerm)
        const _paginas = _arrPerm.map(item => Permissions.pagesAccess(item)).flat();
        // console.log("🚀 ~ Home ~ componentWillMount ~ _paginas:", _paginas)
        this.setState({
            paginas: _paginas,
            arrayPerm: _arrPerm
        })

    }

    checkPerm(arrayPerm, paginas) {
        // if (["admin"].some(r => paginas.indexOf(r) >= 0)) return this.cardsHomeMOCK;
        // else if ([4].some(r => arrayPerm.indexOf(r) >= 0))
        //     return this.cardsHomeMOCK.filter(
        //         item =>
        //             item.paginaPerm !== "admin" &&
        //             item.paginaPerm !== "produtos"
        //     )
        // else if ([14, 20].some(r => arrayPerm.indexOf(r) >= 0)) return this.cardsHomeMOCK.filter(item => item.paginaPerm === "conteúdo");
        // else if (["conteúdo"].some(r => paginas.indexOf(r) >= 0)) {
        //     return this.cardsHomeMOCK.filter(item => arrayPerm.indexOf(item.numeroPerm) >= 0)
        // } else {
        //     return this.cardsHomeMOCK.filter(item => Array(`${item.paginaPerm}`).some(r => paginas.indexOf(r) >= 0))
        // }

        let arrayFinal = [];

        if ([14].some(r => arrayPerm.indexOf(r) >= 0)) arrayFinal = arrayFinal.concat(this.cardsHomeMOCK.filter(item => item.paginaPerm === "conteúdo"));
    
        if (["conteúdo"].some(r => paginas.indexOf(r) >= 0)) {

            if (arrayPerm.indexOf(24) >= 0) {
                const allContentPermissions = [5, 6, 7, 8, 10, 11];
                console.log("@@@@",arrayPerm)
                arrayFinal = arrayFinal.concat(this.cardsHomeMOCK.filter(item => allContentPermissions.concat(arrayPerm).indexOf(item.numeroPerm) >= 0))
                console.log("####",arrayFinal)
                // const baseAllowed = [5, 6, 7, 8, 10, 11];

                // const allContentPermissions = paginas.filter(item => item.name === "Conteúdo")[0].childrens.map(child => child.numPer);

                // const userContentPermissions = allContentPermissions.filter(numPer => arrayPerm.indexOf(numPer) >= 0);

                // const allowed = [...new Set([...baseAllowed, ...userContentPermissions])];

                // const arrayFinal = arrayFinal.filter(item => item.name === "Conteúdo")[0].childrens.filter(p => allowed.indexOf(p.numPer) >= 0).map(i => i.numPer)
            } else arrayFinal = arrayFinal.concat(this.cardsHomeMOCK.filter(item => arrayPerm.indexOf(item.numeroPerm) >= 0))

        }
        if (["admin"].some(r => paginas.indexOf(r) >= 0)) {
            return this.cardsHomeMOCK;
        } else if ([4].some(r => arrayPerm.indexOf(r) >= 0)) {
            return this.cardsHomeMOCK.filter(
                item =>
                    item.paginaPerm !== "admin" &&
                    item.paginaPerm !== "produtos"
            );
        }
        else {
            arrayFinal = arrayFinal.concat(this.cardsHomeMOCK.filter(c => c.paginaPerm !== "conteúdo").filter(item => Array(`${item.paginaPerm}`).some(r => paginas.indexOf(r) >= 0)))
        }
        return arrayFinal

    }

    render() {
        return (
            <div className="row home">
                <div className="col-12">
                    <div className="row opcoes-home">
                        {this.checkPerm(this.state.arrayPerm, this.state.paginas).map((item, index) => {
                            return (
                                <div key={`card-${index}`} className="col-12 col-lg-3 py-3">
                                    <NavLink to={item.link}>
                                        {/* <a className="text-secondary" href={`${window.origin}/${item.link}`}> */}
                                        <div className="card card-home">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className='col-12'>
                                                        <i className={`fas ${item.icon} fa-2x`}></i>
                                                    </div>
                                                    <div className='col-12 pt-2 nome-item'>
                                                        {item.nome}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </NavLink>
                                    {/* </a> */}
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        )
    }
}

export default Home;